import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationStatusPluginService extends InspectionPluginService {
  private statusTypesKeys = [
    { value: 0, label: 'plugins.installationstatus.na' },
    { value: 1, label: 'plugins.installationstatus.ok' },
    { value: 2, label: 'plugins.installationstatus.not-ok' }
  ];

  private statusTypes = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getStatusTypes() {
    return this.statusTypes;
  }

  public updateStatus(inspectionId: string, pointId: string, pluginId: string, status: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, status).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.statusTypes = [];
    this.copyTranslationValues(this.statusTypesKeys, this.statusTypes, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, status: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, status).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
